<template>
    <div class="full-screen-overlay">
      <div class="spinner"></div>
    </div>
</template>

<script>
export default {
  name: 'FullScreenOverlay'
}
</script>

<style scoped lang="scss" src="./FullScreenOverlay.scss">

</style>
